(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-collection"] && !Shopify.designMode) return;
  try {
    
  /**
   * Sets an explicit height on the hero image wrapper, computed from the ratio of the image it holds. The ratio comes
   * from the intrinsic dimensions, so the height is set before the image has loaded.
   */
  class HeroImage extends HTMLElement {
    connectedCallback() {
      this.image = this.querySelector('img');

      if (!this.image) {
        return;
      }

      this.update = this.update.bind(this);
      this.update();

      // The intrinsic dimensions are only known once the image has loaded when it has no width and height attributes
      if (!this.image.complete) {
        this.image.addEventListener('load', this.update, { once: true });
      }

      window.addEventListener('resize', this.update);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.update);
    }

    get ratio() {
      const width = this.image.naturalWidth || parseFloat(this.image.getAttribute('width'));
      const height = this.image.naturalHeight || parseFloat(this.image.getAttribute('height'));

      return width && height ? width / height : 0;
    }

    update() {
      const ratio = this.ratio;
      const width = this.getBoundingClientRect().width;

      // The wrapper is hidden on mobile, where it has no width to compute a height from
      if (!ratio || !width) {
        return;
      }

      this.style.height = `${width / ratio}px`;
      this.setAttribute('resolved', '');
    }
  }

  if (!window.customElements.get('hero-image')) {
    window.customElements.define('hero-image', HeroImage);
  }

  } catch(e) { console.error(e); }
})();
})();
